import React, { useEffect, useRef, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { salesInvoiceViewAction } from "../../../redux/actions/sales-action";
import CreateEditViewSalesInv from "../../../components/sales-section/sales-invoice/create-edit-view-sales-Inv";
const ITEMS_PER_PAGE = 15;
const AUTO_LOAD_ITEM_LIMIT = 100;
const SCROLL_LOAD_MORE_THRESHOLD_PX = 100;

const getItemKey = (item) => `${item?.item_id ?? ""}-${item?.sodtt_id ?? ""}`;

const SalesInvoiceView = () => {
  const { id } = useParams();
  const [orderDetail, setOrderDetail] = useState({});
  const [invoiceItems, setInvoiceItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [itemsLoading, setItemsLoading] = useState(false);
  const [hasMoreItems, setHasMoreItems] = useState(false);
  const [frameNumber, setFrameNumber] = useState(0);
  const dispatch = useDispatch();
  const itemsRef = useRef([]);
  const isFetchingRef = useRef(false);
  const fetchedFramesRef = useRef(new Set());
  const scrollScheduledRef = useRef(false);

  useEffect(() => {
    if (frameNumber > 0) setItemsLoading(true);
    getSalesInvoiceView({
      id,
      frame_number: frameNumber,
      limit: ITEMS_PER_PAGE,
      for_clone: false,
    });
  }, [frameNumber]);

  const getSalesInvoiceView = (params) => {
    if (isFetchingRef.current || fetchedFramesRef.current.has(params.frame_number)) {
      return;
    }
    isFetchingRef.current = true;
    fetchedFramesRef.current.add(params.frame_number);
    dispatch(salesInvoiceViewAction(params, onSuccPur, onErrPur));
  };

  const onSuccPur = (data) => {
    // The endpoint returns { data: [invoice] }; the second arm covers the
    // paginated envelope ({ data: { data: [invoice], next_sequence_exist } })
    // for if/when the backend is switched over to it.
    const result = data?.data?.[0] ?? data?.data?.data?.[0];
    setOrderDetail(result);

    const newItems = result?.itemData ?? [];
    const seen = new Set(itemsRef.current.map(getItemKey));
    const uniqueNewItems = newItems.filter((item) => !seen.has(getItemKey(item)));
    itemsRef.current = [...itemsRef.current, ...uniqueNewItems];
    setInvoiceItems(itemsRef.current);

    const more = !!data?.data?.next_sequence_exist;
    setHasMoreItems(more);
    isFetchingRef.current = false;
    setLoading(false);

    if (more && itemsRef.current.length < AUTO_LOAD_ITEM_LIMIT) {
      setFrameNumber((data?.data?.frame_number ?? 0) + 1);
    } else {
      setItemsLoading(false);
    }
  };

  const onErrPur = (data) => {
    isFetchingRef.current = false;
    setItemsLoading(false);
    setLoading(false);
  };

  const loadMoreItems = () => {
    if (!hasMoreItems || isFetchingRef.current) return;
    setFrameNumber((prev) => prev + 1);
  };

  const handleScroll = (e) => {
    if (scrollScheduledRef.current) return;
    scrollScheduledRef.current = true;
    const target = e.target;
    requestAnimationFrame(() => {
      scrollScheduledRef.current = false;
      const { scrollTop, scrollHeight, clientHeight } = target;
      if (scrollHeight - scrollTop - clientHeight < SCROLL_LOAD_MORE_THRESHOLD_PX) {
        loadMoreItems();
      }
    });
  };

  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <InnerLayout backBtn={true} title="View Sales Invoice">
          <CreateEditViewSalesInv
            payto={orderDetail?.orderData?.soit_pay_to_address}
            shipto={orderDetail?.orderData?.soit_ship_to_address}
            pageType="invoice"
            data={orderDetail}
            page="view"
            type={"delivery"}
            disabled={true}
            orderDetail={invoiceItems}
            vendorDetails={[orderDetail?.orderData]}
            isNotViewOnly={false}
            itemsLoading={itemsLoading}
            onItemsScroll={handleScroll}
          />
        </InnerLayout>
      )}
    </>
  );
};
export default SalesInvoiceView;
